<template>
    <div>
        <el-breadcrumb class="breadcrumb" separator="/" v-if="$route.path !== '/'">
            <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index">
                <span>{{ item.meta.name }}</span>
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
<script>
import { ref, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
export default {
    setup() {
        const route = useRoute();
        const breadcrumbs = ref([]);

        watchEffect(() => {
            const matched = route.matched;
            const matchedArr = matched.filter(item => {
                return item.name && item.name !== '' && item.name !== 'admin';
            });
            breadcrumbs.value = matchedArr;
        });
        return { breadcrumbs };
    }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
    // width: 100%;
    padding-left: 20px;
    background-color: #ffffff;
    height: 100%;
    display: flex;
    align-items: center;
}

.breadcrumb_div {
    position: relative;
}

.back {
    position: fixed;
    background-color: #fff;
    width: 40px;
    height: 40px;
    right: 40px;
    top: 76px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
    z-index: 5;
    color: #409eff;
}
</style>
